import { InjectionToken } from '@angular/core';

/**
 * Whether the app is currently running inside the Control Tower Android-native
 * webview. Resolves to `true` when the native bridge has been injected onto the
 * window.
 *
 * Prefer injecting this token over reading `window.CT_Native_AppBar` directly so
 * webview behaviour can be overridden in tests and consistently reasoned about.
 */
export const IS_CT_WEB_VIEW = new InjectionToken<boolean>('IsCtWebView', {
    providedIn: 'root',
    factory: () => !!window.CT_Native_AppBar,
});
